import { ViewStream } from 'spyne';
import { DeckControlsViewTraits } from 'traits/ui/deck-controls-view-traits.js';
import DeckControlsTmpl from './templates/deck-controls-view.tmpl.html';

export class DeckControlsView extends ViewStream {
  constructor(props = {}) {
    props.class = 'deck-controls';
    props.role = 'toolbar';
    props['aria-label'] = 'Deck controls';
    props.channels = ['CHANNEL_FULLSCREEN'];
    props.traits = [DeckControlsViewTraits];
    props.template = DeckControlsTmpl;
    super(props);
  }

  addActionListeners() {
    return [['CHANNEL_FULLSCREEN_CHANGE_EVENT', 'deckControls$OnFullscreenChange']];
  }

  broadcastEvents() {
    return [['button', 'click']];
  }
}
